module.exports = __webpack_public_path__ + "theme/assets/img/238f0c9d3f79c8ff9010478facbe0808.jpg";